module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAXUlEQVQokd2RsQ2AMBADz4i98i2ZCCaAiaBNJnsaCqBBeqWIcPeFrfdZAClNTkC1HgIQgHsoA0kADCH3S+P9MMszsH54tlL25fERdFKnHROzHOtz4eiHyc8mbrLOCboeHbR6snHbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/05c.png
// module id = pP+p
// module chunks = 64